/* eslint-disable max-lines */

import { createScopedTranslationKeys } from '@dreryk/react-common';

export const translations = {
   pl: {
      patient: {
         accountPartiallyBlocked:
            'Twoje konto zostało częściowo zablokowane z powodu nieopłaconej w terminie faktury - opłać fakturę i skontaktuj się z działem sprzedaży.',
         addPatientButton: 'Dodaj pacjenta',
         addPatientTitle: 'Dodaj pacjenta',
         addressAndContactDetails: 'Adres zamieszkania i dane kontaktowe',
         basicData: 'Dane podstawowe',
         birthDate: 'Data urodzenia',
         cancel: 'Anuluj',
         cannotBeDateInFuture: 'Nie może być datą w przyszłości.',
         cannotBeDateInPast: 'Nie może być datą w przeszłości.',
         cannotRemovePatient: 'Nie można usunąć pacjenta',
         close: 'Zamknij',
         confirmExit: 'Czy na pewno chcesz przerwać edytowanie danych pacjenta?',
         connectWithPatient: 'Połącz z pacjentem',
         consentsAndAuthorizationsPanel: {
            authorizations: {
               accessToMedicalData: 'Dostęp do danych medycznych',
               addAuthorization: 'Dodaj upoważnienie',
               additionAuthorization: 'Dodaj osobę upoważnioną',
               authorizationAdded: 'Upoważnienie dodane',
               authorizationExitConfirmationButtonLabel: 'Wyjdź',
               authorizationExitConfirmationMessage:
                  'Czy chcesz wyjść z formularza? <bold>Utracisz niezapisane dane.</bold>',
               authorizationLeaveForm: 'Wychodzisz z formularza',
               authorizationModified: 'Upoważnienie zmodyfikowano.',
               authorizationScope: 'Zakres upoważnienia',
               authorizationWithdrawn: 'Usunięto upoważnienie.',
               basicData: 'Dane podstawowe',
               chooseAtLeastOneAuthorization: 'Wybierz co najmniej jeden zakres upoważnienia',
               confirmWithdrawAuthorization: 'Usuń',
               contactData: 'Dane kontaktowe',
               documentationAccess:
                  'Upoważnienie do uzyskiwania dokumentacji medycznej o stanie zdrowia i udzielonych świadczeniach medycznych',
               informationAccess:
                  'Upoważnienie do otrzymywania informacji o stanie zdrowia i udzielonych świadczeniach medycznych',
               loadingAuthorizations: 'Ładowanie upoważnień',
               modifyAuthorization: 'Edytuj upoważnienie',
               noAuthorizations: 'Brak upoważnień',
               patientDidNotGiveAuthorization:
                  'Pacjent nie udzielił żadnego upoważnienia na dostęp do swoich danych medycznych.',
               removeAuthorization: 'Usunięcie upoważnienia',
               selectAtLeastOne: 'Wybierz co najmniej jeden.',
               table: {
                  authorizationDate: 'Data upoważnienia',
                  authorizations: 'Zakres',
                  authorizedPerson: 'Osoba upoważniona',
                  medicalDocumentation: 'Dokumentacja medyczna',
                  medicalInformation: 'Informacja o stanie zdrowia',
                  phoneNumber: 'Telefon',
               },
               withdrawAuthorizationMessage:
                  'Czy na pewno chcesz usunąć upoważnienie dla <bold>{{firstName}} {{lastName}}</bold>?',
            },
            consent: {
               consentEntered: 'Zgoda wprowadzona',
               consentHasBeenEntered: 'Zgoda została wprowadzona.',
               consentHasBeenWithdrawn: 'Zgoda została wycofana.',
               consentProvideMedicalServicesAndProcessPersonalData:
                  'Zgoda na udzielanie świadczeń medycznych oraz przetwarzanie danych osobowych',
               consentWithdrawn: 'Zgoda wycofana: {{date}}',
               doesPatientConsentToProvisionMedicalServicesAndProcessingPersonalData:
                  'Czy pacjent wyraża zgodę na udzielanie świadczeń medycznych oraz przetwarzanie danych osobowych?',
               enterConsent: 'Tak, wyraża zgodę',
               granted: 'Zgoda udzielona: {{date}}',
               loadingLastConsent: 'Ładowanie ostatniej zgody',
               noInfo: 'Brak informacji o zgodzie pacjenta',
               withdrawButtonLabel: 'Wycofaj zgodę',
               withdrawConsent: 'Zgoda na udzielanie świadczeń medycznych',
               withdrawQuestion: 'Czy na pewno chcesz wycofać zgodę pacjenta na udzielanie świadczeń medycznych?',
            },
            consentsAndAuthorizations: {
               documentTemplateModal: {
                  actions: {
                     approveAndPrint: 'Zatwierdź i drukuj',
                  },
                  confirmationModal: {
                     actions: {
                        confirm: 'Wyjdź',
                     },
                     description: 'Czy chcesz wyjść z formularza? <bold>Utracisz niezapisane dane.</bold>',
                  },
               },
               header: 'Zgody i upoważnienia',
               modal: {
                  actions: {
                     close: 'Zamknij',
                  },
                  form: {
                     actionInput: {
                        placeholder: 'Wyszukaj dokument po nazwie...',
                     },
                     table: {
                        columns: {
                           actions: {
                              fill: 'Uzupełnij',
                              markAsFavorite: {
                                 successMessage: 'Dokument został dodany do ulubionych.',
                                 tooltipMessage: 'Dodaj do ulubionych',
                              },
                              unmarkAsFavorite: {
                                 successMessage: 'Dokument został usunięty z ulubionych.',
                                 tooltipMessage: 'Usuń z ulubionych',
                              },
                           },
                           headers: {
                              name: 'Nazwa dokumentu',
                           },
                        },
                        noConsentsAndAuthorizationsDocumentsPlaceholder:
                           'Brak dokumentów dotyczących zgód i upoważnień.',
                     },
                  },
                  title: 'Zgody i upoważnienia',
               },
               patientConsentDocumentScannerModal: {
                  actions: {
                     addScan: 'Dodaj skan',
                  },
                  title: 'Dodaj skan do dokumentu "{{documentName}}"',
               },
               patientConsentDocumentsModal: {
                  actions: {
                     close: 'Zamknij',
                  },
                  table: {
                     label: 'Załączniki',
                  },
               },
               table: {
                  actions: {
                     addConsentOrAuthorization: 'Dodaj dokument zgody lub upoważnienia',
                  },
                  columns: {
                     actions: {
                        addDocumentScan: 'Dodaj skan dokumentu',
                        relatedVisit: {
                           backActionLabel: 'Wróć do zgód i upowaźnień',
                           label: 'Podgląd wizyty',
                           tooltip: {
                              noAccessToMedicalData: 'Nie masz dostępu do danych medycznych.',
                              visitNotFinished: 'Wizyta jeszcze nie została zatwierdzona.',
                           },
                        },
                     },
                     headers: {
                        attachments: 'Skan z podpisem',
                        attachmentsUploadDate: 'Data dod. skanów',
                        creationDate: 'Data utworzenia',
                        name: 'Nazwa dokumentu',
                        relatedVisit: 'Utworzony na wizycie',
                     },
                  },
                  noConsentsAndAuthorizationsPlaceholder: {
                     header: 'Brak innych zgód i upoważnień pacjenta',
                     subheader: 'Nie dodano jeszcze żadnej innej zgody i upoważnienia dla tego pacjenta.',
                  },
               },
            },
            printModal: {
               chooseAtLeastOneToPrint: 'Wybierz co najmniej jeden dokument do wydruku',
               confirmAction: 'Drukuj',
               informationAccess: 'Dostęp do informacji o stanie zdrowia',
               medicalAccess: 'Dostęp do danych medycznych',
               modalMessage: 'Wybierz dokumenty do druku.',
               patientConsent: 'Zgoda na udzielenie świadczeń',
               printAction: 'Drukuj',
               title: 'Drukowanie zgód i upoważnień',
            },
            tabName: 'Zgody i upoważnienia',
         },
         copyVideoConsultationLinkForPatient: 'Skopiuj link dla pacjenta',
         dataHasBeenSaved: 'Wszystkie dane zostały zapisane',
         datePlaceholder: 'dd.mm.rrrr',
         encounterMode: {
            ON_SITE: 'Wizyta stacjonarna',
            VIDEO_CONSULTATION: 'Wideokonsultacja',
         },
         entitlementStatements: {
            addEntitlementStatement: 'Dodaj uprawnienie do świadczeń',
            archiveModal: {
               delete: 'Usuń',
               enterReason: 'Uzupełnij powód usunięcia...',
               exitConfirmationModal: {
                  leave: 'Wyjdź',
               },
               reason: 'Powód',
               title: 'Usuwasz uprawnienie do świadczeń',
            },
            confirmationModal: {
               confirmLabel: 'Drukuj',
               description:
                  'Wprowadzone daty złożenia i obowiązywania są różne. <bold>Czy na pewno chcesz wydrukować oświadczenie?</bold>',
               title: 'Drukujesz oświadczenie z różnymi datami',
            },
            createModal: {
               addNewGuardianData: 'Wprowadź dane innego opiekuna',
               addTheDateOfGrantingTheEntitlementStatement: 'Dodaj datę udzielenia świadczenia (opcjonalne)',
               beneficiary: 'Świadczeniobiorcy',
               confirmButton: 'Zatwierdź i drukuj',
               documentAdded: 'Dodano dokument.',
               documentType: 'Typ dokumentu',
               documentTypeDescription: 'Oświadczenie o uprawnieniu do świadczeń',
               effectiveDate: 'Data obowiązywania',
               errors: {
                  loadData: 'Wystąpił błąd pobierania danych.',
               },
               firstNameAndLastName: 'Imię i nazwisko',
               grantingDate: 'Data udzielenia świadczenia',
               grantingDateTooltip:
                  'Należy wypełnić tylko w przypadku, gdy oświadczenie nie jest składane w dniu udzielenia świadczenia',
               guardian: 'Opiekun',
               guardianData: 'Dane opiekuna',
               identityDocument: 'Dokument potwierdzający tożsamość',
               legalBasis: 'Podstawa prawna',
               patientData: 'Dane pacjenta',
               pesel: 'PESEL',
               printWithExplanationsAndNotice: 'Wydrukuj z objaśnieniami i pouczeniem',
               representative: 'Przedstawiciela',
               statementType: 'Typ oświadczenia',
               submissionDate: 'Data złożenia',
            },
            effectiveDate: 'Data obowiązywania',
            entitlementStatement: 'Oświadczenie o uprawnieniu do świadczeń',
            entitlementStatements: 'Uprawnienia do świadczeń',
            identityDocument: 'Dokument potw. tożsamość',
            legalBasis: {
               ACT_2_1_3_A: 'Z tytułu obywatelstwa polskiego i miejsca zamieszkania na terytorium RP',
               ACT_2_1_3_B:
                  'Z tytułu uzyskania statusu uchodźcy, ochrony uzupełniającej lub zezwolenia na pobyt czasowy',
               ACT_2_1_3_C:
                  'Z tytułu pobierania renty rodzinnej przez osobę, która nie ukończyła 18 roku życia, zamieszkującej na terytorium państwa członkowskiego',
               ACT_2_1_4_A:
                  'Z tytułu ciąży, porodu lub połogu oraz posiadania obywatelstwa polskiego i miejsca zamieszkania na terytorium RP',
               ACT_2_1_4_B:
                  'Z tytułu uzyskania statusu uchodźcy, ochrony uzupełniającej lub zezwolenia na pobyt czasowy oraz w okresie ciąży',
               ACT_54_1: 'Z tytułu uzyskania decyzji (wójta/burmistrza/prezydenta)',
               ACT_67_4_TO_7: 'Z tytułu zachowania prawa do świadczeń po wygaśnięciu obowiązku ubezpieczenia',
               POLISH_HEALTHCARE_INSURANCE: 'Z tytułu objęcia ubezpieczeniem zdrowotnym',
            },
            noAdditionalEntitlements: 'Brak dokumentów uprawnień do świadczeń',
            noAdditionalEntitlementsAssignedToPatient:
               'Nie dodano jeszcze żadnego dokumentu potwierdzającego uprawnienie do świadczeń.',
            printInProgress: 'Przygotowywanie druku',
            representativeIdentityDocument: '{{documentType}} przedstaw.: {{documentValue}}',
            submissionDate: 'Data złożenia',
            typeOfDocument: 'Rodzaj dokumentu',
         },
         entitlements: {
            addAdditionalEntitlement: 'Dodaj uprawnienie dodatkowe',
            addEntitlement: 'Dodaj uprawnienie',
            additionalEntitlementDocumentDataWasSaved: 'Dane dokumentu uprawnień dodatkowych zostały zapisane.',
            additionalEntitlementDocumentWasSaved: 'Zapisano uprawnienie dodatkowe.',
            additionalEntitlements: 'Uprawnienia dodatkowe',
            category: 'Kategoria',
            chooseDate: 'Wybierz datę',
            confirmingDocumentName: 'Nazwa dokumentu',
            confirmingDocumentNumber: 'Numer dokumentu',
            documentKind: 'Rodzaj dokumentu',
            documentValidityRangeCantBeLongerThanNineMonths:
               'Okres ważności dokumentu nie może być dłuższy niż 9 miesięcy',
            editAdditionalEntitlement: 'Edytuj uprawnienie dodatkowe',
            endDateCantBeBeforeStartDate: 'Nie może być wcześniejsza niż data "Obowiązuje od"',
            endDateCantBeInPast: 'Nie może być datą w przeszłości',
            entitlementCategory: 'Kategoria uprawnień',
            insertConfirmingDocumentNumber: 'Wprowadź numer dokumentu',
            issueDate: 'Data wystawienia dokumentu',
            noAdditionalEntitlements: 'Brak uprawnień dodatkowych',
            noAdditionalEntitlementsAssignedToPatient:
               'Nie przypisano jeszcze żadnych uprawnień dodatkowych dla tego pacjenta',
            patientEntitlementValidityOverlapsExistingEntitlementFault:
               'Daty dokumentów potwierdzających uprawnienia dodatkowe nakładają się na siebie.',
            patientEntitlements: {
               ARMY_DISABLED: 'Inwalida wojskowy',
               BLOOD_DONOR: 'Zasłużony krwiodawca lub dawca przeszczepu',
               INJURED_VETERAN: 'Weteran poszkodowany',
               PREGNANCY: 'Kobieta w ciąży i w okresie połogu',
               WAR_DISABLED: 'Inwalida wojenny',
            },
            prescriptionIssueDateNotIncluded: 'Okres ważności dokumentu nie obejmuje daty wystawienia eRecepty',
            selectCategory: 'Wybierz kategorię',
            selectConfirmingDocumentName: 'Wybierz nazwę dokumentu',
            startDateCantBeAfterEndDate: 'Nie może być późniejsza niż data "Obowiązuje do"',
            startDateCantBeInFuture: 'Nie może być datą w przyszłości',
            validityDate: 'Data ważności dokumentu',
            validityDateRange: 'Okres ważności dokumentu',
            validityFrom: 'Obowiązuje od',
            validityTo: 'Obowiązuje do',
         },
         filtersPanel: {
            fetchError: 'Nie udało się pobrać danych, spróbuj ponownie',
            patientGroups: {
               allOptions: 'Wszystkie opcje',
               choosePatientGroups: 'Wybierz oznaczenia pacjenta',
               chosenOptions: 'Wybrano {{count}} z {{totalCount}}',
               patientGroup: 'Oznaczenie pacjenta',
            },
         },
         goBackToMedicalRecordFromVideoCall: 'Wróć do kartoteki z wideokonsultacji',
         goBackToPatientData: 'Wróć do kartoteki',
         goBackToPatientList: 'Wróć na listę pacjentów',
         guardianPesel: 'PESEL opiekuna: {{guardianPesel}}',
         guardians: {
            actualGuardian: 'Opiekun faktyczny',
            addGuardian: 'Dodaj opiekuna',
            addNewGuardian: 'Dodaj nowego opiekuna',
            chosenGuardian: 'Wybrany opiekun',
            creationDate: 'Data wprowadzenia',
            doYouWantToRemoveGuardian: 'Czy na pewno chcesz usunąć tego opiekuna?',
            editGuardian: 'Edytuj opiekuna',
            editGuardianData: 'Edytuj dane opiekuna',
            father: 'Ojciec',
            fillPatientDataForSearch: 'Uzupełnij nazwisko, imię, identyfikator lub numer telefonu',
            guardian: 'Opiekun',
            guardianAlreadyExist: 'Opiekun o podanym identyfikatorze już istnieje',
            guardianDataSaved: 'Zapisano dane opiekuna {{fullName}}.',
            guardianNotUsingPesel: 'Opiekun używa innego identyfikatora niz PESEL.',
            guardianRelation: {
               ACTUAL_GUARDIAN: 'Opiekun faktyczny',
               FATHER: 'Ojciec',
               MOTHER: 'Matka',
               NEXT_OF_KIN: 'Inny krewny',
            },
            guardianRemoved: 'Usunięto opiekuna {{fullName}}.',
            guardianRequiredData: 'Dla opiekuna wymagane jest podanie imienia, nazwiska oraz PESELu',
            guardianSameAsPatient: 'Nie można przypisać pacjenta jako swojego własnego opiekuna.',
            guardians: 'Opiekunowie',
            identifyingGuardian: 'Nie można usunąć tego opiekuna, ponieważ jest powiązany z identyfikatorem pacjenta',
            leaveForm: 'Wyjdź z formularza',
            leaveFormMessage: 'Istnieją niezapisane dane. Czy na pewno chcesz opuścić bieżący widok i utracić te dane?',
            mother: 'Matka',
            nextOfKin: 'Inny krewny',
            no: 'Nie',
            noGuardians: 'Brak opiekunów',
            noGuardiansAssignedToPatient: 'Nie przypisano jeszcze żadnego opiekuna dla tego pacjenta',
            patientNotFound: 'Nie znaleziono pacjenta',
            phone: 'Telefon',
            phoneAbbreviation: 'tel.',
            relation: 'Pokrewieństwo',
            remove: 'Usuń',
            removeGuardian: 'Usuń opiekuna',
            requiredAddressDataForStatutoryRepresentative:
               'Dla przedstawiciela ustawowego pacjenta wymagane jest podanie danych adresowych',
            save: 'Zapisz',
            selectGuardianFromPatientsList: 'Wyszukaj opiekuna z listy pacjentów',
            statutoryRepresentative: 'Przedstawiciel ustawowy',
            statutoryRepresentativeAddressData: 'Dane adresowe przedstawiciela ustawowego pacjenta',
            yes: 'Tak',
         },
         heading: 'Pacjenci',
         identityDocument: {
            identityDocument: 'Dokument potwierdzający tożsamość',
            identityDocumentIssuingCountry: {
               label: 'Kraj wydania',
               validate: {
                  invalidIssuingCountry: 'Niepoprawny kraj wydania',
               },
            },
            identityDocumentSeriesAndNumber: {
               label: 'Seria i numer',
               placeholder: 'np. AA12345',
               validate: {
                  invalidSeriesAndNumber: 'Niepoprawna seria lub numer dokumentu',
               },
            },
            identityDocumentType: {
               label: 'Rodzaj dokumentu',
               typeName: {
                  DrivingLicense: 'Prawo jazdy',
                  IdentityCard: 'Dowód osobisty',
                  None: 'Brak',
                  Passport: 'Paszport',
                  SeamansBook: 'Książeczka żeglarska',
                  StudentCard: 'Legitymacja szkolna',
               },
            },
            identityDocumentValidTo: {
               label: 'Data ważności',
               placeholder: 'dd.mm.rrrr',
               validate: {
                  cannotBeDateInPast: 'Nie może być datą w przeszłości',
               },
            },
         },
         incorrectEmailAddress: 'Niepoprawny format adresu e-mail',
         incorrectPhoneNumber: 'Niepoprawny format numeru telefonu',
         incorrectPostCodeFormat: 'Niepoprawny format kodu pocztowego',
         insertAdditionalData: 'Uzupełnij dodatkowe dane',
         invalidMedicalRecordNumber: 'Niepoprawny numer kartoteki',
         invalidNationalIdentificationNumber: 'Niepoprawny numer PIN UE',
         invalidNationalIdentificationNumberPattern: 'Nie może zawierać znaków: ^ | ~ \\ &',
         invalidPassport: 'Niepoprawny paszport',
         invalidPassportPattern: 'Nie może zawierać białych znaków.',
         leaveForm: 'Wyjdź z formularza',
         medicalDocumentRepository: {
            noDocuments: 'Brak dokumentów',
            patientHasNoDocuments: 'Ten pacjent nie ma jeszcze żadnych dokumentów.',
            removedVisible: 'Pokazuj usunięte',
            tabName: 'Repozytorium',
            table: {
               creationDate: 'Data i godzina utworzenia dokumentu',
               documentAuthor: 'Autor dokumentu',
               documentType: 'Rodzaj dokumentu',
               documentVersion: 'Wersja dokumentu',
               removedStatus: 'Usunięto',
            },
         },
         medicalDocumentationCreate: {
            authorizedConfidentialWarning:
               'Dokumentacja nie będzie zawierała danych poufnych wprowadzonych przez inne osoby.',
            back: 'Wstecz',
            categories: {
               ALLERGY: 'Uczulenia',
               ANALYTICAL_TEST_RESULT: 'Wyniki badań analitycznych',
               ANTHROPOMETRY: 'Antropometria',
               CHRONIC_DISEASE: 'Choroby przewlekłe',
               DIAGNOSIS: 'Rozpoznania',
               GYNECOLOGICAL_INTERVIEW: 'Wywiad ginekologiczny',
               HOSPITALIZATION: 'Hospitalizacje',
               MEDICAL_CONSULTATION: 'Konsultacje medyczne',
               MEDICAL_IMAGING: 'Wyniki badań obrazowych',
               OTHER: 'Inne',
               REFERRAL: 'Skierowanie',
               REHABILITATION: 'Rehabilitacje',
               RISK_FACTOR: 'Czynniki ryzyka',
               TREATMENT: 'Zabiegi i operacje',
            },
            confidentialAnnotationCheckbox: 'Dodaj do dokumentu adnotację o danych poufnych',
            create: 'Utwórz',
            createPatientRecords: 'Utwórz dokumentację pacjenta',
            createPatientRecordsModal: {
               actions: {
                  downloadEncrypted: 'Zaszyfruj i pobierz',
                  downloadUnencrypted: 'Pobierz bez szyfrowania',
               },
               medicalDocumentationShareButtonLabel: 'Udostępnij pacjentowi',
               title: 'Utwórz dokumentację pacjenta',
            },
            createPatientRecordsReady:
               'Wydruk dokumentacji medycznej został przygotowany i jest dostępny do pobrania w <link />.',
            createdAndDownloadedPatientRecords: 'Utworzono i pobrano dokumentację pacjenta',
            createdAndSentPatientRecords: 'Utworzono i wysłano dokumentację pacjenta',
            dateFrom: 'Data od',
            dateTo: 'Data do',
            entirePeriod: 'Całość dokumentacji',
            generatingDocumentation: 'Generowanie dokumentacji',
            myAccount: 'Moje konto',
            removed: 'Usunięty',
            repository: 'Repozytorium',
            selectedRange: 'Wybrany zakres dat',
            send: 'Wyślij',
            sendingDocumentation: 'Wysyłanie dokumentacji',
            sentDocumentationToPatientAndSmsMessageWithPassword:
               'Wysłaliśmy dokumentację do pacjenta oraz wiadomość SMS z poniższym hasłem.',
            shareRecordsWithPatient: 'Udostępnij dokumentację pacjentowi',
            unableToCreateDocumentationNoUserIdentifier:
               'Nie udało się utworzyć dokumentacji - brak identyfikatora użytkownika. Dodaj go w panelu <link />.',
         },
         medicalInformation: {
            addEntry: 'Dodaj wpis do kartoteki',
            addEntryModal: {
               addEntry: 'Dodaj wpis',
               cancel: 'Anuluj',
               chooseFileFromDrive: 'Wybierz plik z dysku',
               chooseMedicalInformationType: 'Wybierz rodzaj informacji medycznej',
               confirmLeavingForm: 'Czy na pewno chcesz przerwać dodawanie wpisu?',
               entryCategory: 'Kategoria wpisu',
               fetchingMedicineInformationTypes: 'Pobieranie listy rodzajów wpisów',
               leaveForm: 'Wyjdź z formularza',

               youCannotEditEntry: 'Dodając wpis tworzysz dokumentację medyczną. Dokonanego wpisu nie można edytować.',
            },
            buyExtraStorageLimit: 'Dokup dodatkowy pakiet danych',
            chronicDisease: {
               details: {
                  diagnosis: 'Rozpoznanie',
                  diagnosisCreatedPerson: 'Osoba stwierdzająca rozpoznanie',
                  entryDate: 'Data wpisu',
                  entryRemovalDate: 'Data wykreślenia wpisu',
                  entryRemovalOnDoctorRequest: 'zlecający: Lekarz',
                  entryRemovalPerson: 'Osoba wykreślająca wpis',
                  entryRemovalReason: 'Powód wykreślenia wpisu',
               },
               form: {
                  create: {
                     currentPractitioner: {
                        label: 'Uzupełnij moimi danymi',
                     },
                     diagnosisCreationBy: {
                        licenceNumber: {
                           label: 'Numer PWZ',
                        },
                        name: {
                           label: 'Osoba stwierdzająca rozpoznanie',
                           placeholder: 'Uzupełnij osobę...',
                        },
                     },
                     diagnosisCreationDate: {
                        label: 'Data wpisu',
                     },
                     diagnosisRemovalBy: {
                        licenceNumber: {
                           label: 'Numer PWZ',
                        },
                        name: {
                           label: 'Wykreślenie na zlecenie',
                           placeholder: 'Uzupełnij osobę...',
                        },
                     },
                     diagnosisRemovalDate: {
                        label: 'Data wykreślenia wpisu',
                        validate: {
                           cannotBeAfterRemovalDate: 'Nie może być datą późniejszą niż data wykreślenia wpisu.',
                           cannotBeBeforeCreationDate: 'Nie może być datą wcześniejszą niż data wpisu.',
                        },
                     },
                     disease: {
                        label: 'Rozpoznanie',
                        placeholder: 'Uzupełnij kod ICD-10 lub nazwę choroby...',
                     },
                     removalReason: {
                        label: 'Powód wykreślenia wpisu',
                        placeholder: 'Podaj powód wykreślenia wpisu...',
                     },
                  },
               },
               table: {
                  createdBy: 'Osoba dokonująca wpisu',
                  description: 'Opis',
                  diagnosedBy: 'Osoba stwier. rozpoznanie',
                  diagnosis: 'Rozpoznanie',
                  diagnosisCreationDate: 'Data wpisu',
                  diagnosisRemovalDate: 'Data do',
                  removedBy: 'Osoba Wykreślająca wpis',
               },
            },
            diagnosis: {
               table: {
                  chronic: 'Przewlekłe',
                  createdBy: 'Osoba przeprowadzająca wizytę',
                  creationDate: 'Data',
                  diagnosis: 'Rozpoznanie',
                  main: 'Główne',
                  options: {
                     showVisit: {
                        backActionLabel: 'Wróć do danych medycznych',
                        label: 'Podgląd wizyty',
                     },
                  },
               },
               tooltip: 'Lista obejmuje rozpoznania stwierdzone w dokumentacji wewnętrznej.',
            },
            externalDocumentationStorageLimitExceeded:
               'Wykorzystałeś dostępne miejsce na dokumentację zewnętrzną. <link />',
            failedToFetchMedicalInformation: 'Nie powiodło się pobranie danych medycznych',
            gynecologicalInterview: {
               addEntry: 'Dodaj wpis',
               addEntryAndSendToP1: 'Dodaj wpis i wyślij do P1',
               choose: 'Wybierz',
               determinedOnBasis: 'Wyznaczona na podstawie',
               interviewType: {
                  DEAD_DELIVERY: 'Poród martwy',
                  DELIVERY: 'Poród',
                  MISCARRIAGE: 'Poronienie',
                  OTHER: 'Inny powód zakończenia ciąży',
                  PATIENT_PREGNANT: 'Pacjentka w ciąży',
                  REGULAR_INTERVIEW: 'Wywiad ginekologiczny',
               },
               medicalEventStatus: {
                  ERROR: 'Błąd rejestracji Zdarzenia Medycznego - {{errorMessage}}',
                  NONE: 'Wpis dodany bez raportowania Zdarzenia Medycznego',
                  OUTDATED: 'Przedawnione Zdarzenie Medyczne - {{errorMessage}}',
                  PENDING: 'Oczekujące Zdarzenie Medyczne',
                  REGISTERED: 'Zarejestrowane Zdarzenie Medyczne',
               },
               multiplePregnancy: 'ciąża mnoga',
               predictedCompletionDate: 'Przewidywana data porodu',
               predictedCompletionDateBasis: {
                  EXAMINATION: 'Badania',
                  LAST_MENSTRUATION: 'Ostatniej menstruacji',
                  LAST_OVULATION: 'Ostatniej owulacji',
               },
               pregnancyCompletionDate: 'Data zakończenia ciąży',
               pregnancyConfirmed: 'potwierdzona',
               pregnancyUnconfirmed: 'niepotwierdzona',
               table: {
                  dataPreview: 'Podgląd danych',
                  description: 'Opis',
                  enteredBy: 'Osoba dokonująca wpisu',
                  entry: 'Wpis',
                  entryDate: 'Data wpisu',
                  identificationType: {
                     MEDICAL_LICENCE_NUMBER: 'NPWZ',
                     PESEL: 'PESEL',
                  },
                  medicalEvent: 'ZM',
               },
               type: 'Typ',
            },
            lack: 'Brak',
            markAsRemoved: 'Oznacz jako usunięty',
            medicalImaging: {
               addEntry: 'Dodaj wpis',
               details: {
                  examinationDate: 'Data badania',
                  procedure: 'Procedura medyczna',
               },
               form: {
                  examinationDate: {
                     label: 'Data badania',
                  },
                  examinationTime: {
                     label: 'Godzina',
                  },
                  procedureSelector: {
                     label: 'Procedura medyczna',
                     placeholder: 'Uzupełnij kod ICD-9 lub nazwę procedury...',
                  },
               },
               table: {
                  creationDate: 'Data wpisu',
                  description: 'Opis',
                  entryAuthor: 'Osoba dokonująca wpisu',
                  procedure: 'Procedura medyczna',
               },
            },
            medicalLicenceNumberAbbreviation: 'NPWZ',
            noEntries: 'Brak wpisów',
            patientHasNoEntries: 'Ten pacjent nie ma jeszcze żadnych wpisów',
            previewModal: {
               attachmentRemoved: 'Usunięty',
               closePreview: 'Zamknij podgląd',
               description: 'Opis',
               haveBeenSigned: 'Podpisano.',
               markAsRemovedAttachmentModal: {
                  info: 'Czy na pewno chcesz oznaczyć załącznik jako usunięty?',
                  reason: {
                     MISTAKE: 'Omyłkowo dodany załącznik',
                     OTHER: 'Inny',
                     descriptionPlaceholder: 'Doprecyzuj powód usunięcia...',
                     label: 'Powód usunięcia',
                  },
                  remove: 'Oznacz jako usunięty',
                  title: 'Usuwasz załącznik z danych medycznych',
               },
               personEnteringEntry: 'Osoba dokonująca wpisu',
               personSigningAttachments: 'Osoba podpisująca załączniki',
               sign: 'Podpisz',
            },
            qrCodeGenerateFailed: 'Nie udało się załadować kodu QR skanera dokumentów',
            removed: 'Usunięty',
            sectionName: '{{name}} ({{count}})',
            shared: {
               fields: {
                  confidentialityLevel: {
                     confidentialityLevelMap: {
                        CONFIDENTIAL: 'Poufny',
                        NORMAL: 'Normalny',
                     },
                     label: 'Poziom poufności danych',
                  },
                  descriptionTextarea: {
                     label: 'Opis',
                     placeholder: 'Uzupełnij opis...',
                  },
               },
               table: {
                  attachments: 'Załączniki',
               },
            },
            showRemoved: 'Pokazuj usunięte',
            successfullyAddedNewEntry: 'Dane medyczne zostały dodane.',
            tabName: 'Dane medyczne',
            table: {
               medicalInformation: {
                  dataPreview: 'Podgląd danych',
                  description: 'Opis',
                  enteredBy: 'Osoba dokonująca wpisu',
                  entryDate: 'Data wpisu',
                  identificationType: {
                     MEDICAL_LICENCE_NUMBER: 'NPWZ',
                     PESEL: 'PESEL',
                  },
               },
            },
         },
         medicalRecordNumber: 'Nr kart.: {{medicalRecordNumber}}',
         menuLabel: 'Pacjenci',
         // TODO DREGAB-15544: Do react-common
         middleName: 'Drugie imię',

         nfzDepartment: {
            choose: 'Wybierz',
            fetchingDepartments: 'Pobieranie listy oddziałów NFZ',
            label: 'Oddział NFZ',
         },

         notes: {
            modal: {
               addNote: 'Dodaj notatkę',
               addNoteTitle: 'Dodaj notatkę o pacjencie',
               author: 'Autor',
               cancelAdd: 'Czy na pewno chcesz przerwać dodawanie notatki?',
               cancelEdit: 'Czy na pewno chcesz przerwać edycję notatki?',
               confirmRemoval: 'Usuń',
               editNoteTitle: 'Edytuj notatkę o pacjencie',
               label: 'Treść',
               placeholder: 'Uzupełnij treść notatki',
               removeNote: 'Usuwasz notatkę',
               removeNoteConfirmation: 'Czy na pewno usunąć notatkę?',
               saveNote: 'Zapisz',
            },
         },

         passport: 'Paszport: {{passport}}',
         passportCountry: 'Kraj wydania paszportu',
         passportValidTo: 'Data ważności',
         patientAlreadyExists:
            'Pacjent z identyfikatorem typu "{{identifier}}" o podanej wartości już istnieje w systemie.',
         patientCannotBeRemovedReason:
            'Nie można usunąć pacjenta, dla którego prowadzona i przechowywana jest dokumentacja medyczna, posiada umówione wizyty na dzisiaj lub w przyszłości.',
         patientData: 'Dane pacjenta',
         patientDataCreated: 'Dane pacjenta zostały dodane.',
         patientDataRemoved: 'Dane pacjenta zostały usunięte.',
         patientDataUpdated: 'Dane pacjenta zostały zaktualizowane.',
         patientFetchError: 'Nie udało się pobrać danych pacjenta. Spróbuj ponownie.',
         patientGroups: {
            tabName: 'Oznaczenia pacjenta',
         },
         patientHistory: 'Historia pacjenta',
         patientOverYearOld: 'Pacjent powyżej roku, musi mieć własny identyfikator',
         patientRegisterVisit: 'Rejestruj wizytę',
         patientRemovalReason: 'Przyczyna usunięcia pacjenta',
         patientsFile: 'Kartoteka pacjenta',
         personalData: {
            birthDate: {
               label: 'Data urodzenia',
               placeholder: 'dd.mm.rrrr',
            },
            downloadFromEwus: {
               configureEwus: 'Skonfiguruj eWUŚ w zakładce Moje konto',
               downloadFromEwus: 'Pobierz dane z eWUŚ',
               downloadedPatientFromEwus: 'Pobrano imię i nazwisko z eWUŚ.',
               downloadingEwusPatient: 'Pobieranie danych pacjenta',
               ewus: 'eWUŚ',
               ewusConfigurationFetchError: 'Błąd pobierania danych logowania do eWUŚ. <tryAgainLink />',
               ewusData: 'Dane z eWUŚ',
               ewusDataIsDifferent: 'Dane z kartoteki i z systemu eWUŚ różnią się. Czy zastąpić dane?',
               file: 'Kartoteka',
               firstName: 'Imię',
               lastName: 'Nazwisko',
               leaveFromFile: 'Zostaw dane z kartoteki',
               patientNotReplaced: 'Zostawiono imię i nazwisko z formularza.',
               patientReplacedWithEwusPatient: 'Uzupełniono imię i nazwisko danymi z eWUŚ.',
               replace: 'Zastąp',
               tryAgain: 'Spróbuj ponownie',
               type: 'Rodzaj',
            },
            identifierType: {
               displayName: {
                  BirthDate: 'Data urodzenia',
                  GuardianPesel: 'PESEL opiekuna',
                  MedicalRecordNumber: 'Nr kart.',
                  NationalIdentificationNumber: 'PIN UE',
                  Passport: 'Paszport',
                  Pesel: 'PESEL',
               },
               faultMap: {
                  GUARDIAN_PESEL: 'PESEL opiekuna',
                  MEDICAL_RECORD_NUMBER: 'Numer kartoteki',
                  NATIONAL_IDENTIFICATION_NUMBER: 'Osobisty numer identyfikacyjny (R)',
                  PASSPORT: 'Paszport',
                  PESEL: 'PESEL',
               },
               label: 'Typ identyfikatora',
               typeName: {
                  BirthDate: 'Data urodzenia',
                  GuardianPesel: 'PESEL opiekuna',
                  MedicalRecordNumber: 'Numer kartoteki',
                  NationalIdentificationNumber: 'Osobisty numer identyfikacyjny (R)',
                  Passport: 'Paszport',
                  Pesel: 'PESEL',
               },
            },
            identifierValue: {
               label: 'Identyfikator',
               placeholder: {
                  BirthDate: '',
                  NationalIdentificationNumber: 'PIN UE',
                  Passport: 'seria i numer paszportu',
                  Pesel: '',
               },
               validate: {
                  invalidNationalIdentificationNumber: 'Niepoprawny numer PIN UE',
                  invalidNationalIdentificationNumberPattern: 'Nie może zawierać znaków: ^ | ~ \\ &',
                  invalidPassport: 'Niepoprawny paszport',
                  invalidPassportPattern: 'Nie może zawierać białych znaków.',
                  invalidPesel: 'Niepoprawny numer PESEL',
               },
            },
            nationalIdentificationNumberCountry: {
               label: 'Kraj nadania',
            },
            passportCountry: {
               label: 'Kraj wydania paszportu',
            },
            passportValidTo: {
               label: 'Data ważności',
               placeholder: 'dd.mm.rrrr',
               validate: {
                  cannotBeDateInPast: 'Nie może być datą w przeszłości.',
               },
            },
            tabName: 'Dane osobowe',
         },
         personalIdentifier: 'Identyfikator',
         personalIdentifierType: 'Typ identyfikatora',
         pesel: 'PESEL: {{peselVal}}',
         phoneAbbreviation: 'tel',
         pinue: 'PIN UE: {{nationalIdentificationNumber}}',
         prescriptionsHistory: 'Historia recept',
         prescriptionsHistoryFilters: {
            allSpecialists: 'Wszyscy specjaliści',
            chooseSpecialists: 'Wybierz specjalistów',
            chosenSpecialists: 'Wybrano {{doctorsCount}} specjalistów',
            onlyContinuouslyUsed: 'Tylko stałe',
            onlyMine: 'Tylko moje',
         },
         registerVisitAndGoBackToPatientListButton: 'Zarejestruj i wróć na listę pacjentów',
         removePatient: 'Usuń pacjenta',
         repeatSelectedPrescriptions: 'Powtórz wybrane recepty',
         save: 'Zapisz',
         searchPlaceholder: 'Wpisz nazwisko, imię, identyfikator, numer telefonu lub nazwę oznaczenia...',
         searchReachedMaxNumberOfCharacters: 'Maksymalna liczba znaków w wyszukiwarce wynosi 100.',
         sendingCountry: 'Kraj nadania',
         serialAndPassportNumber: 'seria i numer paszportu',
         shared: {
            attachmentsLinks: {
               and: 'i',
               moreAvailableAttachmentsCount: {
                  accusative: '{{restAttachmentsCount}} inne',
                  genitive: '{{restAttachmentsCount}} innych',
                  nominative: '{{restAttachmentsCount}} inny',
               },
               moreRemovedAttachmentsCount: {
                  accusative: '{{count}} usunięte',
                  genitive: '{{count}} usuniętych',
                  nominative: '{{count}} usunięty',
               },
               or: 'oraz',
               restAttachments: '{{count}} {{declensionForm}}',
            },
         },
         table: {
            address: 'Adres',
            noPatientsAdded: 'Brak dodanych pacjentów.',
            noSearchResults: 'Brak pasujących pacjentów.',
            options: 'Opcje',
            patientName: 'Nazwisko i imię',
            phone: 'Telefon',
         },
         tabsId: 'zakladki',
         unavailableInDemo: 'Niedostępne w wersji demo',
         unconfirmed: {
            associateFiles: 'Powiąż kartoteki',
            associateWithExistingFile: 'Powiąż z istniejącą kartoteką',
            associateWithExistingPatient: 'powiąż z istniejącym pacjentem',
            associatingFileData: 'Dane wiązanej kartoteki',
            close: 'Zamknij',
            copy: 'Skopiuj',
            country: 'Kraj',
            dataIsInconsistent: 'Nie wszystkie dane się pokrywają - upewnij się, że chcesz powiązać te kartoteki.',
            email: 'E-mail',
            existingPatientFile: 'Istniejąca kartoteka pacjenta',
            fillPatientDataForSearch: 'Wpisz nazwisko, imię, identyfikator lub nr telefonu...',
            firstName: 'Imię',
            flat: 'Nr mieszkania',
            fullName: 'Imię i nazwisko',
            house: 'Nr domu',
            lastName: 'Nazwisko',
            middleName: 'Drugie imię',
            missingIdentityNumberInfo:
               'Pacjent nie posiada identyfikatora. Dodaj identyfikator lub <patientAssociateLink />, by zobaczyć wszystkie kartoteki pacjenta.',
            patientSearchItem: {
               age: 'Wiek',
               guardianPesel: 'PESEL opiekuna',
               medicalRecordNumber: 'Nr kart.',
               passport: 'Paszport',
               pesel: 'PESEL',
               phoneAbbreviation: 'tel.',
               pinue: 'PIN UE',
            },
            patientsFilesAssociated: 'Powiązano kartoteki pacjentów.',
            phoneNumber: 'Telefon',
            postcode: 'Kod pocztowy',
            save: 'Zapisz',
            saveAndStartVisit: {
               exceptions: {
                  alreadyCancelled: 'Wizyta została już anulowana.',
                  alreadyStarted: 'Wizyta została już rozpoczęta.',
               },
               label: 'Zapisz i rozpocznij wizytę',
            },
            street: 'Ulica',
            thisValueIsDifferent: 'Ta wartość się różni.',
            town: 'Miejscowość',
         },
      },
   },
};

export const patientTranslationKeys = createScopedTranslationKeys(translations.pl, 'patient');
export const personalDataTranslationKeys = patientTranslationKeys.personalData;
export const patientConsentsAndAuthorizationsTranslationKeys = patientTranslationKeys.consentsAndAuthorizationsPanel;
export const downloadPersonalDataFromEwusTranslationKeys = patientTranslationKeys.personalData.downloadFromEwus;
export const patientMedicalInformationTranslationKeys = patientTranslationKeys.medicalInformation;
export const patientMedicalDocumentRepositoryTranslationKeys = patientTranslationKeys.medicalDocumentRepository;
export const guardiansTranslationKeys = patientTranslationKeys.guardians;
export const patientEntitlementsTranslationKeys = patientTranslationKeys.entitlements;
export const notesTranslationKeys = patientTranslationKeys.notes;
export const medicalDocumentationCreateTranslationKeys = patientTranslationKeys.medicalDocumentationCreate;
export const entitlementStatementsTranslationKeys = patientTranslationKeys.entitlementStatements;
export const identityDocumentTranslationKeys = patientTranslationKeys.identityDocument;
export const gynecologicalInterviewTranslationKeys = patientTranslationKeys.medicalInformation.gynecologicalInterview;
export const sharedTranslationKeys = patientTranslationKeys.shared;
export const filtersPanelTranslationKeys = patientTranslationKeys.filtersPanel;
